var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanySetup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.05 9.8H3.86C3.24394 9.8 2.93591 9.8 2.70061 9.91989C2.49363 10.0254 2.32535 10.1936 2.21989 10.4006C2.1 10.6359 2.1 10.9439 2.1 11.56V20.8M16.95 9.8H20.14C20.7561 9.8 21.0641 9.8 21.2994 9.91989C21.5064 10.0254 21.6746 10.1936 21.7801 10.4006C21.9 10.6359 21.9 10.9439 21.9 11.56V20.8M16.95 20.8V4.52C16.95 3.28788 16.95 2.67183 16.7102 2.20122C16.4993 1.78726 16.1627 1.45071 15.7488 1.23979C15.2782 1 14.6621 1 13.43 1H10.57C9.33788 1 8.72183 1 8.25122 1.23979C7.83726 1.45071 7.50071 1.78726 7.28979 2.20122C7.05 2.67183 7.05 3.28788 7.05 4.52V20.8M23 20.8H1M10.9 5.4H13.1M10.9 9.8H13.1M10.9 14.2H13.1",
    stroke: "#4A65A6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanySetup);
export default __webpack_public_path__ + "static/media/company_setup.690bb02a134cff065eaf2764bd60acfe.svg";
export { ForwardRef as ReactComponent };